// extracted by mini-css-extract-plugin
export default {"secondaryButton":"secondary-button_secondaryButton__EPQBu"};